var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyOat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.446,
    xmlns: "http://www.w3.org/2000/svg",
    height: 300.446,
    id: "screenshot-e97d6340-1ad2-806c-8002-8eb2f9dd593f",
    viewBox: "-0.223 -0.223 300.446 300.446",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-e97d6340-1ad2-806c-8002-8eb2f9dd593f",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-e97d6340-1ad2-806c-8002-8eb145f30870",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-e97d6340-1ad2-806c-8002-8eb145f30872"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-e97d6340-1ad2-806c-8002-8eb145f30872"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M150.269,275.000C133.033,275.025,116.830,271.768,101.661,265.228C86.491,258.688,73.221,249.750,61.850,238.412C50.479,227.075,41.501,213.824,34.916,198.658C28.331,183.493,25.026,167.283,25.000,150.030C24.974,132.776,28.231,116.556,34.771,101.372C41.311,86.187,50.250,72.961,61.587,61.694C72.925,50.427,86.176,41.501,101.342,34.916C116.507,28.331,132.717,25.026,149.970,25.000C167.224,24.974,183.444,28.231,198.628,34.771C213.813,41.311,227.039,50.198,238.306,61.431C249.573,72.664,258.499,85.880,265.084,101.079C271.669,116.277,274.974,132.495,275.000,149.731C275.025,166.967,271.768,183.170,265.228,198.339C258.688,213.509,249.802,226.760,238.569,238.092C227.335,249.425,214.120,258.403,198.921,265.026C183.723,271.650,167.505,274.974,150.269,275.000ZL150.269,275.000ZM150.314,256.250C179.793,256.206,204.830,245.804,225.424,225.044C246.018,204.284,256.293,179.165,256.250,149.686C256.206,120.207,245.876,95.170,225.259,74.576C204.643,53.981,179.503,43.706,149.842,43.750C120.467,43.794,95.430,54.124,74.732,74.741C54.033,95.357,43.706,120.497,43.750,150.158C43.794,179.533,54.196,204.570,74.956,225.268C95.716,245.966,120.835,256.293,150.314,256.250ZL150.314,256.250ZM150.000,150.000L150.000,150.000Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a3"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M118.777,235.205C118.777,235.205,121.586,188.993,154.323,142.075C172.071,116.638,178.368,100.806,210.777,80.205",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a3",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M118.777,235.205C118.777,235.205,121.586,188.993,154.323,142.075C172.071,116.638,178.368,100.806,210.777,80.205",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a4"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M145.170,81.741C145.170,81.741,136.473,91.674,140.028,106.620C144.512,125.472,157.228,132.437,157.228,132.437C157.228,132.437,161.497,130.954,162.945,125.066C164.638,118.188,162.480,105.298,145.170,81.741Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a4",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M145.170,81.741C145.170,81.741,136.473,91.674,140.028,106.620C144.512,125.472,157.228,132.437,157.228,132.437C157.228,132.437,161.497,130.954,162.945,125.066C164.638,118.188,162.480,105.298,145.170,81.741Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a5"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M171.072,60.607C171.072,60.607,164.613,68.168,167.500,79.759C171.141,94.381,180.865,99.926,180.865,99.926C180.865,99.926,184.079,98.836,185.100,94.307C186.292,89.015,184.490,79.030,171.072,60.607Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a5",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M171.072,60.607C171.072,60.607,164.613,68.168,167.500,79.759C171.141,94.381,180.865,99.926,180.865,99.926C180.865,99.926,184.079,98.836,185.100,94.307C186.292,89.015,184.490,79.030,171.072,60.607Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a6"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M121.170,122.741C121.170,122.741,112.473,132.674,116.028,147.620C120.512,166.472,133.228,173.437,133.228,173.437C133.228,173.437,137.497,171.954,138.945,166.066C140.638,159.188,138.480,146.298,121.170,122.741Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a6",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M121.170,122.741C121.170,122.741,112.473,132.674,116.028,147.620C120.512,166.472,133.228,173.437,133.228,173.437C133.228,173.437,137.497,171.954,138.945,166.066C140.638,159.188,138.480,146.298,121.170,122.741Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a7"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M96.168,170.972C96.168,170.972,90.356,182.912,97.731,196.419C107.033,213.457,121.184,216.789,121.184,216.789C121.184,216.789,124.929,214.211,124.784,208.126C124.614,201.019,119.134,189.126,96.168,170.972Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a7",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M96.168,170.972C96.168,170.972,90.356,182.912,97.731,196.419C107.033,213.457,121.184,216.789,121.184,216.789C121.184,216.789,124.929,214.211,124.784,208.126C124.614,201.019,119.134,189.126,96.168,170.972Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a8"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M169.891,181.229C169.891,181.229,169.491,194.426,156.708,202.946C140.583,213.693,126.528,210.129,126.528,210.129C126.528,210.129,124.414,206.135,127.364,200.838C130.811,194.650,141.171,186.684,169.891,181.229Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a8",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M169.891,181.229C169.891,181.229,169.491,194.426,156.708,202.946C140.583,213.693,126.528,210.129,126.528,210.129C126.528,210.129,124.414,206.135,127.364,200.838C130.811,194.650,141.171,186.684,169.891,181.229Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3a9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3a9"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M187.426,147.266C187.426,147.266,184.983,160.240,171.032,166.673C153.435,174.787,140.104,169.086,140.104,169.086C140.104,169.086,138.634,164.812,142.371,160.038C146.736,154.459,158.207,148.197,187.426,147.266Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3a9",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M187.426,147.266C187.426,147.266,184.983,160.240,171.032,166.673C153.435,174.787,140.104,169.086,140.104,169.086C140.104,169.086,138.634,164.812,142.371,160.038C146.736,154.459,158.207,148.197,187.426,147.266Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-990d4e43f3aa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-990d4e43f3aa"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M213.303,109.263C213.303,109.263,211.106,122.281,197.279,128.977C179.839,137.422,166.402,131.974,166.402,131.974C166.402,131.974,164.852,127.729,168.498,122.884C172.757,117.224,184.107,110.746,213.303,109.263Z",
    style: {
      fill: "rgb(177, 178, 181)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-990d4e43f3aa",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M213.303,109.263C213.303,109.263,211.106,122.281,197.279,128.977C179.839,137.422,166.402,131.974,166.402,131.974C166.402,131.974,164.852,127.729,168.498,122.884C172.757,117.224,184.107,110.746,213.303,109.263Z",
    style: {
      fill: "none",
      strokeWidth: 10,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyOat);
export default __webpack_public_path__ + "static/media/grey_oat.49ed593454e4dde96c76450a650339b9.svg";
export { ForwardRef as ReactComponent };